import { ActionCardModel } from '@playbooks/action-cards-utils'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

export default class WebPlayActionCardService {
  baseService!: WebPlayActionCardService

  constructor(serviceSource: WebPlayActionCardService | ActionCardModel | ActionCard) {
    if (!serviceSource) {
      return
    }
    if ((serviceSource as WebPlayActionCardService).getActionCardModel) {
      this.baseService = serviceSource as WebPlayActionCardService
    } else if (serviceSource instanceof ActionCardModel) {
      this.baseService = {
        getActionCardModel: function () {
          return serviceSource
        },
      } as WebPlayActionCardService
    } else {
      const actionCardModel = new ActionCardModel(serviceSource as unknown as ActionCard)
      this.baseService = {
        getActionCardModel: function () {
          return actionCardModel
        },
      } as WebPlayActionCardService
    }
  }

  getActionCardModel(): ActionCardModel | undefined {
    return this.baseService?.getActionCardModel?.()
  }

  getEmailNode() {
    const emails = this.baseService?.getActionCardModel?.()?.getSearchService().filterEmails().toSearchService()

    if (!emails) {
      return
    }

    return (
      emails.filterNotEmptyInputNodes().filterVisible().find() ??
      emails.filterVisible().find() ??
      emails.filterNotEmptyInputNodes().find() ??
      emails.find()
    )
  }

  adjustEmail(email: string | null) {
    if (!email) {
      return
    }

    const emailNodesSearchService = this.baseService
      ?.getActionCardModel?.()
      ?.getSearchService()
      .filterEmails()
      .toSearchService()

    if (!emailNodesSearchService) {
      return
    }

    const emailNode = emailNodesSearchService.filterVisible().find() ?? emailNodesSearchService.find()
    emailNode?.setValue(email)
  }

  adjustModelFromQueryString(searchParams: Pick<URLSearchParams, 'entries'>) {
    const modesSearchService = this.baseService?.getActionCardModel?.()?.getSearchService()
    if (!modesSearchService) {
      return
    }
    for (const { questionCode, value } of iterateInitialNodesValuesFromQueryString(searchParams)) {
      // try/catch is used to suppress expected exceptions (e.g. setValue of FileQuestionNode)
      try {
        modesSearchService.findQuestionByCode(questionCode)?.setStringValue(value)
      } catch (ex) {
        console.error(ex)
      }
    }
  }
}

function* iterateInitialNodesValuesFromQueryString(searchParams: Pick<URLSearchParams, 'entries'>) {
  const nodeValueParameterPrefix = 'f_'
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith(nodeValueParameterPrefix)) {
      yield { questionCode: key.substring(nodeValueParameterPrefix.length), value }
    }
  }
}
